import { render, staticRenderFns } from "./LRadio.vue?vue&type=template&id=6b08fd23&scoped=true"
import script from "./LRadio.vue?vue&type=script&lang=js"
export * from "./LRadio.vue?vue&type=script&lang=js"
import style0 from "./LRadio.vue?vue&type=style&index=0&id=6b08fd23&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b08fd23",
  null
  
)

export default component.exports